import { useEffect, useState } from 'react'

import { PhnxButton } from '../../01-atoms/Button/Button'
import styles from './Industry.module.css'

export type ServicesProps = {
  title: string
  href: string
}

export type IndustryProps = {
  advisor: string
  avatar: React.ReactNode
  callback?: string
  content?: React.ReactNode
  relatedServices?: ServicesProps[]
}

export const PhnxIndustry: React.FC<IndustryProps> = ({
  advisor,
  avatar,
  callback,
  content,
  relatedServices,
}) => {
  const [activeLink, setActiveLink] = useState<string>('')

  useEffect(() => {
    const currentPath = window.location.pathname
    setActiveLink(currentPath)

    var currentTitle = document.title
    var newString = ' - Industries | Findex'
    if (!currentTitle.includes(newString)) {
      document.title = currentTitle + newString
    }
  }, [])

  const handleClick = (url: string) => {
    window.location.href = url
  }

  let location = process.env.NEXT_PUBLIC_NEXT_LOCATION
    ? process.env.NEXT_PUBLIC_NEXT_LOCATION
    : 'au'

  return (
    <div className={styles['industry']}>
      <div className={styles['industry-headline']}>
        <div className={` container`}>
          <h2>Industries</h2>
        </div>
      </div>
      <div className={` container`}>
        <div className={`${styles['industry-nav']}`}>
          {location !== 'en-nz' && (
            <button
              onClick={() => handleClick('/industries/education/education-portal')}
              className={`${styles['industry-navitem']} ${activeLink === '/industries/education/education-portal' ? styles['active'] : ''}`}
              disabled={activeLink === '/industries/education/education-portal'}
            >
              <div className={styles['industry-navitem-title']}>Education Portal</div>
            </button>
          )}
          <button
            onClick={() => handleClick('/industries/education/')}
            disabled={activeLink === '/industries/education/'}
            className={`${styles['industry-navitem']} ${activeLink === '/industries/education/' ? styles['active'] : ''}`}
          >
            <div
              className={`${styles['industry-navitem-education']} ${styles['industry-navitem-image']}`}
            >
              {' '}
            </div>
            <div className={styles['industry-navitem-title']}>Education</div>
          </button>
          <button
            onClick={() => handleClick('/industries/agribusiness')}
            disabled={activeLink === '/industries/agribusiness'}
            className={`${styles['industry-navitem']} ${activeLink === '/industries/agribusiness' ? styles['active'] : ''}`}
          >
            <div
              className={`${styles['industry-navitem-agribusiness']} ${styles['industry-navitem-image']}`}
            >
              {' '}
            </div>
            <div className={styles['industry-navitem-title']}>Agribusiness</div>
          </button>
          <button
            onClick={() => handleClick('/industries/medical-and-healthcare')}
            disabled={activeLink === '/industries/medical-and-healthcare'}
            className={`${styles['industry-navitem']} ${activeLink === '/industries/medical-and-healthcare' ? styles['active'] : ''}`}
          >
            <div
              className={`${styles['industry-navitem-medical']} ${styles['industry-navitem-image']}`}
            >
              {' '}
            </div>
            <div className={styles['industry-navitem-title']}>Medical and Healthcare</div>
          </button>
          <button
            onClick={() => handleClick('/industries/franchising')}
            disabled={activeLink === '/industries/franchising'}
            className={`${styles['industry-navitem']} ${activeLink === '/industries/franchising' ? styles['active'] : ''}`}
          >
            <div
              className={`${styles['industry-navitem-franchise']} ${styles['industry-navitem-image']}`}
            >
              {' '}
            </div>
            <div className={styles['industry-navitem-title']}>Franchising</div>
          </button>
          <button
            onClick={() => handleClick('/industries/government')}
            disabled={activeLink === '/industries/government'}
            className={`${styles['industry-navitem']} ${activeLink === '/industries/government' ? styles['active'] : ''}`}
          >
            <div
              className={`${styles['industry-navitem-government']} ${styles['industry-navitem-image']}`}
            >
              {' '}
            </div>
            <div className={styles['industry-navitem-title']}>Government</div>
          </button>
          <button
            onClick={() => handleClick('/industries/not-for-profit')}
            disabled={activeLink === '/industries/not-for-profit'}
            className={`${styles['industry-navitem']} ${activeLink === '/industries/not-for-profit' ? styles['active'] : ''}`}
          >
            <div
              className={`${styles['industry-navitem-notforprofit']} ${styles['industry-navitem-image']}`}
            >
              {' '}
            </div>
            <div className={styles['industry-navitem-title']}>Not For Profit</div>
          </button>
          <button
            onClick={() => handleClick('/industries/trade-and-customs')}
            disabled={activeLink === '/industries/trade-and-customs'}
            className={`${styles['industry-navitem']} ${activeLink === '/industries/trade-and-customs' ? styles['active'] : ''}`}
          >
            <div
              className={`${styles['industry-navitem-trade']} ${styles['industry-navitem-image']}`}
            >
              {' '}
            </div>
            <div className={styles['industry-navitem-title']}>Trade and Customs</div>
          </button>
        </div>
      </div>
      <div className={`${styles['industry-container']} container`}>
        <div className={styles['industry-image']}>
          <div className={styles['content-border']}>
            <div className={styles['industry-title']}>Have a question? Talk to our expert</div>
            {avatar}
            <div>{advisor}</div>
            <PhnxButton variant="primary" label="Request a callback" type="link" href={callback} />
          </div>
          {relatedServices && (
            <div className={styles['border-left']}>
              <h4>
                <strong>Related Services</strong>
              </h4>
              {relatedServices.map((item, index) => (
                <a href={item.href} className={styles.specailty} key={`specialty-${index}`}>
                  {item.title}
                </a>
              ))}
            </div>
          )}
        </div>
        <div className={styles['industry-details']}>
          <div>
            <div>{content}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
